import mapActions from './mapActions';

export default mapActions('tools_at_buildings', {
    fetchAll_url: data => {
        if (data.id === undefined) 
            throw new Error('id of building is undefined');

        return `/api/buildings/${data.id}/tools`;
    }
});